import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { StyledEngineProvider } from "@mui/material/styles";

import BarChartGSLarge from "./BarChartGSLarge";
import BarChartGSSmall from "./BarChartGSSmall";
import BarChartGBALarge from "./BarChartGBALarge";
import BarChartGBASmall from "./BarChartGBASmall";
import LinkButton from "./LinkButton";

const guangshenLink = "/guangshen";
const GBALink = "/gba";

import axios from "axios";

const theme = {
  bgcolor: "#392f30",
  color: "rgba(255, 255, 255, 0.7)",
  "&.Mui-selected": {
    color: "#fff",
  },
  fontSize: "20px",
  fontWeight: "bold",
  p: "30px",
};

const themeSmall = {
  bgcolor: "#392f30",
  color: "rgba(255, 255, 255, 0.7)",
  "&.Mui-selected": {
    color: "#fff",
  },
  fontSize: "19px",
  fontWeight: "bold",
  p: "10px",
};

export default function LabTabs() {
  const [dataGuangshen, setGSlastData] = useState([]);
  const [dataGBA, setGBAData] = useState(null);
  const [value, setValue] = useState("1");

  useEffect(() => {
    axios
      .get("https://thinktank.phbs.pku.edu.cn/api/GuangShenLast")
      .then((response) => setGSlastData(response.data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    axios
      .get("https://thinktank.phbs.pku.edu.cn/api/GBALast")
      .then((response) => setGBAData(response.data[0]))
      .catch(console.error);
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      {/* Large Screens */}
      <div className="largeCharts">
        <StyledEngineProvider injectFirst>
          <Box sx={{ width: "100%" }}>
            <div className="whiteBG">
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList onChange={handleChange} variant="fullWidth">
                    <Tab label="广深经济预测" value="1" sx={theme} />
                    <Tab label="珠三角九市GDP预测" value="2" sx={theme} />
                  </TabList>
                </Box>

                <TabPanel value="1">
                  {dataGuangshen.map((item) => (
                    <BarChartGSLarge
                      key={item.key}
                      forecastDate={item.forecastDate}
                      gdData={item.gdData}
                      szData={item.szData}
                      updateDate={item.updateDate}
                    />
                  ))}
                  <LinkButton link={guangshenLink} />
                </TabPanel>

                <TabPanel value="2">
                  {dataGBA && (
                    <BarChartGBALarge
                      forecastDate={dataGBA.forecastDate}
                      updateDate={dataGBA.updateDate}
                      cityData={dataGBA.cityData}
                      gbaData={dataGBA.gbaData}
                    />
                  )}
                  <LinkButton link={GBALink} />
                </TabPanel>
              </TabContext>
            </div>
          </Box>
        </StyledEngineProvider>
      </div>

      {/* Small Screens */}
      <div className="smallCharts">
        <StyledEngineProvider injectFirst>
          <Box sx={{ width: "100%" }}>
            <div className="whiteBGSmall">
              <TabContext value={value}>
                <Box sx={{ borderBottom: 0 }}>
                  <TabList onChange={handleChange} variant="fullWidth">
                    <Tab label="广深经济预测" value="1" sx={themeSmall} />
                    <Tab label="珠三角GDP预测" value="2" sx={themeSmall} />
                  </TabList>
                </Box>

                <TabPanel value="1">
                  {dataGuangshen.map((item) => (
                    <BarChartGSSmall
                      key={item.key}
                      forecastDate={item.forecastDate}
                      gdData={item.gdData}
                      szData={item.szData}
                      updateDate={item.updateDate}
                    />
                  ))}
                  <LinkButton link={guangshenLink} />
                </TabPanel>

                <TabPanel value="2">
                  {dataGBA && (
                    <BarChartGBASmall
                      forecastDate={dataGBA.forecastDate}
                      updateDate={dataGBA.updateDate}
                      cityData={dataGBA.cityData}
                      gbaData={dataGBA.gbaData}
                    />
                  )}
                  <LinkButton link={GBALink} />
                </TabPanel>
              </TabContext>
            </div>
          </Box>
        </StyledEngineProvider>
      </div>
    </div>
  );
}
